interface AuditResultMapType {
  [propName: string]: string;
}
interface AuditLogStatusMapType {
  [propName: number]: { label: string; color: string };
}

export const AuditResultMap: AuditResultMapType = {
  "0": "安全无感水印发现异常",
  "1": "图片正在上传中，请等待！",
  "2": "文件生成成功",
};
export const uploadMap: AuditResultMapType = {
  success: "上传成功",
  exception: "上传失败",
};

export const AuditLogStatusMap: AuditLogStatusMapType = {
  0: { label: "异常审核", color: "red" },
  1: { label: "异常审核", color: "red" },
  2: { label: "通过", color: "blue" },
};

export const UserTypeMap: AuditResultMapType = {
  user: "普通用户",
  admin: "管理员",
  superadmin: "超级管理员",
};
